import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    table: {
      width: '100%',
      borderCollapse: 'collapse',
    },
    th: {
      textAlign: 'left',
      paddingBottom: theme.spacing(1),
      borderBottom: '2px solid #ddd',
      whiteSpace: 'nowrap',      // Force text to stay on one line
      overflow: 'hidden',        // Hide any overflowed content
      textOverflow: 'ellipsis',  // Add ellipsis for overflowing text
    },
    td: {
      textAlign: 'left',
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      borderBottom: '1px solid #ddd',
      whiteSpace: 'nowrap',      // Force text to stay on one line
      overflow: 'hidden',        // Hide any overflowed content
      textOverflow: 'ellipsis',  // Add ellipsis for overflowing text
    },
    avatar: {
      width: 24,
      height: 24,
      marginRight: theme.spacing(1)
    },
    scoreBadge: {
      borderRadius: '8px',
      padding: '2px 4px',
      fontWeight: 'bold',
      fontSize: '0.75rem',
      display: 'inline-block',
    },
    rankIcon: {
      color: '#e60000',
      marginRight: theme.spacing(1),
      marginBottom: theme.spacing(1),
      width: theme.spacing(3),
      height: theme.spacing(3),
    },
    titleBox: {
      display: 'flex',
      alignItems: 'left',
      justifyContent: 'left',
    },
    progressBar: {
      width: '75%',
      height: theme.spacing(1),
      borderRadius: 10,
      backgroundColor: '#e0e0e0', // Background for the track (empty part)
    },
    productionReadinessColor: {
      backgroundColor: '#ffcc00', // Filled color
    },
    monitoringMaturityColor: {
      backgroundColor: '#2196f3', // Filled color
    },
    doraMetricsColor: {
      backgroundColor: '#ff9800', // Filled color
    },
  }));

  export default useStyles;